import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";
import credential from "../../API/Credentials.json";

const apiMethod = credential?.request?.post;
export const dashboardPiChart = createAsyncThunk(
  "dashboard/dashboardPiChart",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.PiChart_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const dashboardBarChart = createAsyncThunk(
  "dashboard/dashboardBarChart",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.BarChart_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const dashboardBarChartGroup = createAsyncThunk(
  "dashboard/dashboardBarChartGroup",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.BarChartGroup_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    barChartGroup: [],
    piData: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    setPiData: (state, action) => {
      state.piData = action.payload;
    },
    setBarChartGroup: (state, action) => {
      state.barChartGroup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dashboardPiChart.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(dashboardPiChart.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(dashboardPiChart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(dashboardBarChart.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(dashboardBarChart.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(dashboardBarChart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(dashboardBarChartGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(dashboardBarChartGroup.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(dashboardBarChartGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }, 
});
export const { setPiData, setBarChartGroup } = DashboardSlice.actions;
export default DashboardSlice.reducer;
